import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { viewerTranslations } from "../viewer/locale/i18n";

i18n.use(initReactI18next)
  .init({
    fallbackLng: "jp",
    interpolation: {
      escapeValue: false,
    },
    resources: {
      en: {
        translation: {
          Login:"Login",
          Email:"Email Address",
          Password:"Password",
          DontHaveAccount:"Don't have an account?",
          ErrorLogin:"Error : Please verify your Login/Password.",
          Continue:"Continue",
          English:"English",
          Japanese:"Japanese",
          Account: "Account",
          Signout: "Sign out",
          OnlineStorage: "Online Storage",
          NewProject: "New project",
          NoProjectYet: "Your account does not contain any project yet.",
          Needmorespace: "Need more space?",
          Getintouchwithus: "Get in touch with us",
          ContactUs: "Contact Us",
          Welcome: "Welcome to Mirukuru Online Storage!",
          PleaseStart:"Please start by creating a project, by clicking on the button [New project].",
          Moused:"GB used on",
          Momax:"GB",
          NewProjectDescription:"To create a new project, please enter a title and a short description.",
          Title:"Title",
          Description:"Description",
          Cancel:"Cancel",
          Create:"Create",
          Creating:"Creating",
          ProjectEmpty:"This project is empty. Please upload some data, by clicking on the button [Upload].",
          UploadData:"Upload",
          Progress:"Progress",
          Edit:"Edit",
          Delete:"Delete",
          SelectALASFile:"Select a LAS or LAZ file, add a brief description, and attach an image. If needed, select the processing options for this file.",
          LASLAZFile:"LAS/LAZ File (required)",
          Image:"Image (10MB maximum)",
          Materials:"Materials",
          PhotosReconstruction:"Photos",
          SelectPhotos:"Choose the photo set for Gaussian Splatting reconstruction. The output model will be georeferenced using GPS data from the photos EXIF. Note that photos taken indoors or focused on objects may contain GPS tags that aren't suitable for locating the model accurately.",
          PhotosSelectedCount_one:"{{count}} photo selected",
          PhotosSelectedCount_other:"{{count}} photos selected",
          dragndrop:"Drag 'n' drop or click to select",
          Upload:"Upload ",
          Uploading:"Upload",
          ErrorUpload:"An error occured while uploading the data. Please try again.",
          ErrorType:"The file you provided is not in the LAS or LAZ format. Please select a LAS or LAZ file.",
          ErrorSpace:"The file you selected will not fit in your storage space. Get in touch with us to increase your storage space.",
          ErrorMaxFileSpace:"The file you selected exceed the maximum size. Please select a smaller file.",
          ErrorNoFile:"Please select one file.",
          ErrorMultipleFiles:"Only one file can be uploaded at a time unless you include exactly one OBJ with its materials.",
          ErrorObjMultiple:"Please select only one OBJ file.",
          ErrorObjBundleTypes:"OBJ bundles can only include .mtl and texture files (.jpg, .jpeg, .png).",
          ErrorNoFileOrPhotos:"Please select a point cloud file or at least 3 photos.",
          ErrorMinimumPhotos:"Please select at least 3 photos.",
          UploadSuccess:"Data uploaded!",
          EditProject:"Edit project",
          PleaseModify:"Please modify the project name and description.",
          NewTitle:"New title",
          NewDescription:"New description",
          Save:"Save",
          Saving:"Saving",
          Product:"Product",
          Products:"Products",
          Download:"Download",
          Share:"Share",
          DeleteProject:"Delete project",
          DeleteProjectDesc:"Any deleted project, including the attached data, cannot be recovered. Please, proceed with caution.",
          Deleting:"Deleting",
          errorDeleteProject:"An error occured while deleteing the project. Please try again.",
          successDeleteProject:"Project deleted!",
          errorEditProject:"An error occured while editing the project. Please try again.",
          successEditProject:"Project modified!",
          errorCreateNewProject:"An error occured during the project creation. Please check that you filled correctly the title and the description.",
          successCreateNewProject:"Project creation successful!",
          Close:"Close",
          ShareFile:"Share file",
          ShareProduct:"Share product",
          ShareFileDesc:"A link to the file, valid for 24 hours, will be automatically copied to your clipboard. Feel free to share this link to your collaborators. Anybody with this link can download the file.",
          CreateLink:"Create link",
          LinkSuccess:"The link has been copied to your clipboard!",
          DeleteFile:"Delete file",
          DeleteFileDesc:"Any deleted File cannot be recovered. The products associated will also be deleted. Please, proceed with caution.",
          successDeleteFile:"Data deleted!",
          errorDeleteFile:"An error occured during the data deletion, please try again.",
          ErrorAlreadyExists:"This file has already been uploaded on your account, please select another one.",
          ForgotPassword:"Reset or change password",
          ResetPassword:"Reset password",
          ResetPasswordDesc:"Please fill here your email. If your email corresponds to an account in our database, you will receive shortly a verification code for setting up your new password.",
          Send:"Send code",
          SuccessResetPassword:"The code has been successfully sent to your email address.",
          ErrorResetPassword:"The email address your provided does not correspond to any registered account, Please verify that you entered the correct address.",
          NewPasswordDesc:"Please enter here the verification code you received by email and your new password.",
          Code:"Code",
          SuccessNewPassword:"Your password has been changed!",
          ErrorNewPassword:"An error occured while setting your new password. Please check your verification code.",
          errorDownloadFile:"An error occured while downloading the file. Please try again.",
          Searchfile:"Search file",
          Sortby:"Sort by",
          Date:"Date",
          Latest:"Latest",
          Oldest:"Oldest",
          Size:"Size",
          Biggest:"Biggest",
          Smallest:"Smallest",
          File:"File",
          View:"View",
          ErrorPotree:"An error occured during the rendering. Please try again.",
          ErrorPointCloudLoading:"An error occured during the conversion of your dataset. Please inform our team for further inquiry.",
          NewPassword:"Enter your new Password",
          ReNewPassword:"Enter again your new Password",
          minLengthPW: "Password has at least 8 characters.",
					specialCharPW: "Password has special characters.",
					numberPW: "Password has a number.",
					capitalPW: "Password has a capital letter.",
          lowercasePW: "Password has a lowercase letter.",
					matchPW: "Passwords match.",
          TooManyAttempt:"Attempt limit exceeded, please try after some time.",
          CodeMismatchError:"The provided code doesn't match. Please check again your verification code.",
          ViewerNotReady:"The viewer for this file is not ready yet. Please try again after few minutes.",
          UploadingContent:"Uploading content",
          MaximumSize:"Maximum size",
          GettingViewerReady:"The viewer is getting ready.",
          AboutButton:"About",
          About:"About",
          AboutInfo:"Mirukuru Online Storage is a powerful software tool designed for storing and visualizing 3D point clouds online. It enables users to interactively explore and analyze point cloud data with ease.",
          SoftwareStructure:"Software Structure",
          SoftwareStructureInfo:"The software is built on a robust and scalable architecture that handles the secure storage of 3D point cloud data through Amazon Web Services and uses Potree, an open-source point cloud rendering framework, for high-quality and interactive visualization.",
          Potree:"Potree",
          PotreeInfo:"Mirukuru Online Storage uses Potree and Potree Converter for rendering massive point clouds in web browsers. Potree and its converter are renowned for their performance and compatibility with various LiDAR data formats. Both Potree and Potree Converter are under ",
          Contact:"Contact",
          ContactInfo:"For support, inquiries, or feedback, please ",
          ThankYou:"Thank you for choosing Mirukuru Online Storage!",
          TeamSign:"The Mirukuru Team",
          Demo:"This account is intended for demonstration purposes only.",
          UserEmpty:"This user did not upload any data yet.",
          ErrorFileNoSpace:"The name of the file should not contain space character (' '). Please change the file name and try again.",
          NoProductAdmin:"There is no product attached to this file yet.",
          UploadProduct:"Add product",
          AddNewProductAdmin:"Add a new product",
          ErrorConverterHead:"Sorry, the viewer is not available for this file",
          ErrorConverter1:"This can happen for the two following reasons:",
          ErrorConverter2:"Some points fall outside bounding box defined in the LAS header",
          ErrorConverter3:"The Global Encoding (GE) flag is not set to WKT, which is a requirement for Point Data Record Format 6 - 10.",
          ErrorConverter4:"Please try to repair the bounding box, e.g. using lasinfo with the -repair_bb argument, and/or verify that the Global Encoding (GE) flag is set to WKT, then upload your file again.",
          ErrorConverter5:"If the problem persists, do not hesitate to contact our team.",
          SuccessEditUser:"The user has been edited successfully.",
          ErrorEditUser:"An error occured during the user edition.",
          AccountActivity:"Account activity",
          Storage:"Storage ",
          UserCreated:"User created on ",
          Total:"Total ",
          UserSettings1:"User settings",
          UserSettings2:"Storage space",
          UserSettings3:"Maximum size of the directory storing the files uploaded by this user.",
          UserSettings4:"Maximum Go uploaded per month",
          UserSettings5:"During login, we check the number of Go uploaded in the current month by this user. If this number is equal or higher than the limit below, then the user needs to wait for the beginning of the next month to upload a new file.",
          UserDeletionTitle:"Delete user",
          UserDeletionDescription:"Clicking on this button will delete permanently the user and its data from our database. There is no way to recover data that have been deleted.",
          DeleteUser:"Delete",
          ConfirmUserDeletionTitle:"Confirm deletion",
          ConfirmUserDeletionDescription:"Are you sure you want to continue?",
          AdminPanel:"Administration panel",
          StorageStatistics:"Storage statistics",
          Empty:"Empty",
          HasBeenAddedToTheFile:" has been added to ",
          CreatedOn:"Created on ",
          UpdatedOn:"Last updated on ",
          EditData:"Edit data",
          PleaseModifyData:"Please provide a new description and/or a new image.",
          SuccessEditFile:"The file has been modified with success",
          ErrorEditFile:"An error occured during the file modification",
          UploadQueue:"Upload queue",
          UploadCompleted:"Upload completed",
          UploadFailed:"Upload failed",
          NewUser:"Create a new user",
          NewUserDescription:"Please fill in the required fields for creating a new user",
          Name:"Name",
          Company:"Company",
          errorCreateNewUser:"An error occured during the user creation.",
          successCreateNewUser:"User creation successful!",
          successSendInvitationEmail:"Invitation email sent.",
          ErrorDeleteUser:"An error occured during the user deletion.",
          SuccessDeleteUser:"User deleted successfully.",
          errorSendInvitationEmail:"Failed to send invitation email.",
          warningNameNewUser:"Please provide a name for the new user.",
          warningCompanyNewUser:"Please provide a company name for the new user.",
          warningEmailNewUser:"Please provide a valid email for the new user.",
          warningPasswordNewUser:"Please provide a valid password for the new user.",
          warningSelectOneService:"Please select at least one service for the new user.",
          FilterUsers:"Filter users",
          LastLogin:"Last login on ",
          MaxUploadReached:"You reached the maximum of upload this month. Please contact us if you need to upload more files.",
          NumberFile:"Files uploaded",
          NumberGo:"Go uploaded",
          MonthlyUsage:"Monthly usage",
          TotalStorage:"Total storage",
          FileNotReadyForDeletion:"This file is currently being processed, please try to delete it again later.",
          ProcessingOptions:"Processing request",
          Requests:"Requests",
          "forest-report":"Forest report",
          "forest-report-diameter":"Diameter",
          "forest-report-position":"Position",
          "forest-report-height":"Height",
          "noise-filtering":"Noise filtering",
          "ground-extraction":"Ground extraction",
          "buildings-segmentation":"Buildings segmentation",
          "trees-segmentation":"Trees segmentation",
          "crowns-analysis":"Tree crowns analysis",
          "Project":"Project",
          "Projects":"Projects",
          Settings:"Settings of the user storage space and monthly quota.",
          HistoryRequests:"History of the processing requests that have been fulfilled for this user.",
          BuildingSegmentation:"Automatically isolates and extracts building structures from urban point clouds. Using advanced clustering and planar fitting, it delineates roofs, facades and edges even in dense city scans. Outputs clean 3D building footprints and meshes ready for urban planning or visualization.",
          "buildings-segmentation-output":"Mesh model for each detected building, exported in .OBJ format",
          CrownsAnalysis:"Tailored to airborne LiDAR surveys, this tool detects individual tree crowns across large forest canopies. It computes key canopy metrics—height and projection area to assess stand health and structure. Results include crown maps in shapefile format for forest ecologists and silvicultural planning.",
          "crowns-analysis-output":"An ESRI Shapefile bundle (.shp/.shx/.dbf/.prj) containing individual tree‐crown polygons.",
          ForestReport:"Generates a comprehensive stand‐level report from ground‐based point clouds. Aggregates tree metrics—diameter at breast height (DBH), height distributions and tree position into a ready‐to‐share CSV.",
          "forest-report-output":"A CSV file listing both per-tree and stand-level statistics derived from the point cloud.",
          GroundExtraction:"A general‐purpose ground‐surface extraction tool that builds accurate digital terrain models (DTMs). Using progressive morphological and interpolation filters, it classifies and retains only ground points even under vegetation or urban clutter, then approximates those ground points by a continuous surface.",
          "ground-extraction-output":"A georeferenced GeoTIFF (.tif) digital terrain model (DTM) representing the bare-earth surface.",
          NoiseFiltering:"Universal denoising to clean up any point cloud before further processing. Applies statistical outlier removal and radius‐based filters to strip away sensor noise and spurious points while preserving fine details. The result is a high‐quality, ready-to-use point cloud that improves accuracy in downstream tasks.",
          "noise-filtering-output":"A cleaned LAZ-compressed point cloud (.laz) with sensor noise and outliers removed.",
          TreeSegmentation:"Designed for ground‐level or low-altitude scans, this module segments each tree into its own point cloud. You get per-tree datasets for biomass estimation, tree‐by‐tree monitoring or detailed modeling.",
          "trees-segmentation-output":"A LAZ-compressed point cloud file (.laz) augmented with an extra TreeID field.",
          ChooseYourPanel:"Choose your panel",
          ChooseYourPanelDescription:"As an administrator you can choose which dashboard to enter",
          Administrator:"Administrator",
          User:"User",
          Service:"Service",
          ServiceClassic:"Classic",
          ServiceMapping:"Mapping",
          ChooseYourService:"Choose the service",
          ChooseYourServiceDescription:"As a subscriber to both of our service, please select the one you want to log in.",
          ProcessingOptionsSubtitle:"Choose the analyses to run after upload. You can combine multiple options; results will be accessible from your dataset sub-menu.",
          "crowns-analysis-subtitle":"Detects individual tree crowns and measures crown height, and surface area. Outputs crown polygons and a table of per-tree metrics.",
          "forest-report-subtitle":"Summarizes stand-level statistics such as tree count, position, height and diamter. Export a CSV of key metrics.",
          "ground-extraction-subtitle":"Separates ground from non-ground points and builds a clean Digital Terrain Model (DTM). Provides a raster DEM",
          "noise-filtering-subtitle":"Removes outliers and stray points while preserving edges.",
          "trees-segmentation-subtitle":"Segments individual trees from the point cloud using geometry cues. Returns per-tree point IDs for downstream analysis.",
          DownloadUserManual:"User manual",
          FetchingData:"Fetching data",
          Archive:"Archive",
          SelectArchive:"Select a ZIP archive and add a brief description",
          ErrorNoArchive:"Please select an archive file",
          // EPSG Selection Dialog
          SelectCoordinateSystem:"Select Coordinate System",
          DetectedEPSG:"Detected EPSG",
          NotDetected:"Not detected",
          FileCenter:"File center",
          CoordinateSystem:"Coordinate System",
          Zone:"Zone",
          EstimatedZTranslation:"Estimated Z Translation (Geoid Height)",
          CalculatingZTranslation:"Calculating Z translation...",
          ConvertedCenter:"Converted center",
          Confirm:"Confirm",
          ErrorMissingHeader:"Missing file header information",
          ErrorReadingHeader:"Error reading file header",
          ErrorNoGeoReference:"Be careful, the file you submitted does not contain any geo reference information. We will not be able to display it correctly in our viewer. Please select another file.",
          EpsgDialogExplanation:"The 3D viewer uses ellipsoidal heights (based on the WGS84 ellipsoid). If your point cloud uses orthometric heights (based on a geoid model), a vertical offset is needed to align your data with the basemap. Please verify the coordinate system and confirm the Z translation below.",
          ZTranslationExplanation:"This value (geoid undulation N) will be added to your Z coordinates to convert from orthometric to ellipsoidal height.",
          // Height Type Selection
          HeightType:"Height Type",
          EllipsoidHeight:"Ellipsoid Height",
          OrthometricHeight:"Orthometric Height",
          EllipsoidHeightDescription:"The data already uses ellipsoidal heights (e.g., GPS/GNSS elevations). No vertical correction is needed.",
          OrthometricHeightDescription:"The data uses orthometric heights (elevation above sea level/geoid). A vertical offset will be applied.",
          EllipsoidNoTranslation:"No vertical correction needed - data already uses ellipsoidal heights.",
          ZTranslation:"Z Translation",
          DatasetLocation:"Dataset location",
          GeoidSourceJapan:"Source: GSI Geoid 2011 (Japan)",
          GeoidSourceWorld:"Source: EGM2008 (World)",
          FetchingGeoidJapan:"Fetching from GSI Geoid 2011 (Japan)...",
          FetchingGeoidWorld:"Fetching from EGM2008 (World)...",
          // JGD2011 Zone Regions
          JGD2011_Zone1:"Nagasaki, Kagoshima islands",
          JGD2011_Zone2:"Fukuoka, Saga, Nagasaki, Kumamoto",
          JGD2011_Zone3:"Yamaguchi, Shimane, Hiroshima",
          JGD2011_Zone4:"Tottori, Okayama, Hyogo (part)",
          JGD2011_Zone5:"Tokushima, Kagawa, Ehime, Kochi",
          JGD2011_Zone6:"Kyoto, Osaka, Nara, Wakayama, Hyogo (part)",
          JGD2011_Zone7:"Ishikawa, Toyama, Gifu, Aichi",
          JGD2011_Zone8:"Niigata, Nagano, Yamanashi, Shizuoka",
          JGD2011_Zone9:"Tokyo, Fukushima, Tochigi, Ibaraki, Saitama, Chiba, Gunma, Kanagawa",
          JGD2011_Zone10:"Aomori, Akita, Yamagata, Iwate, Miyagi",
          JGD2011_Zone11:"Hokkaido (southwest)",
          JGD2011_Zone12:"Hokkaido (central)",
          JGD2011_Zone13:"Hokkaido (east)",
          JGD2011_Zone14:"Tokyo islands (Ogasawara)",
          JGD2011_Zone15:"Okinawa (main island)",
          JGD2011_Zone16:"Okinawa (Sakishima)",
          JGD2011_Zone17:"Okinawa (Senkaku)",
          JGD2011_Zone18:"Tokyo islands (Minamitorishima)",
          JGD2011_Zone19:"Tokyo islands (Iwo Jima area)",
          Files: "files",
          NoSearchResults: "No files match your search.",
          ClearFilter: "Clear search",
          // Time-limited platform access
          AccessEndedTitle: "Your access has ended",
          AccessEndedMessage: "Your access to Mirukuru Online Storage has expired. To renew your subscription and regain access, please contact the Mirukuru sales team.",
          AccessEndedMessageTrial: "Your trial period for Mirukuru Online Storage has ended. To continue using the platform, please contact the Mirukuru sales team.",
          ContactSales: "Contact sales",
          BackToLogin: "Back to login",
          TrialPeriodWeeks: "Trial period (weeks)",
          TrialPeriodHelp: "The new user will have access to the platform for this number of weeks, after which they will be asked to contact sales.",
          warningTrialWeeks: "Please set a trial period of at least 1 week.",
          AccessManagementTitle: "Access & subscription",
          AccessStatus: "Access status",
          Plan: "Plan",
          PlanUnlimited: "Unlimited",
          PlanTrial: "Trial",
          PlanPaid: "Paid",
          AccessActive: "Active",
          AccessExpiredLabel: "Expired",
          AccessExpiresOn: "Access expires on",
          AccessValidUntil: "Access until",
          AccessStartedOn: "Current period started on",
          NeverExpires: "Never expires (unlimited)",
          DaysRemainingValue: "{{count}} days remaining",
          ActivatePaidAccess: "Activate paid access",
          Duration: "Duration",
          DurationMonths: "{{count}} months",
          ExtendTrial: "Extend trial",
          RevokeAccess: "Revoke access",
          ConfirmRevokeTitle: "Revoke access?",
          ConfirmRevokeMessage: "This user will lose access to the platform immediately and will be asked to contact sales at next login. Continue?",
          AccessUpdatedSuccess: "Access updated successfully.",
          AccessUpdatedError: "An error occurred while updating access.",
          // Viewer translations merged from src/viewer/locale/i18n.js
          ...viewerTranslations.en,
        },
      },
      jp: {
        translation: {
          Login:"ログイン",
          Email:"メールアドレス",
          Password:"パスワード",
          DontHaveAccount:"アカウントをお持ちでない方はこちら",
          ErrorLogin:"エラー： ログイン/パスワードを確認してください。",
          Continue:"続行",
          English:"英語",
          Japanese:"日本語",
          Account: "アカウント",
          Signout: "サインアウト",
          OnlineStorage: "オンラインストレージ",
          NewProject: "新規プロジェクト",
          NoProjectYet: "アカウントにはまだプロジェクトがありません。",
          Needmorespace: "ディスクスペースの増設が必要ですか?",
          Getintouchwithus: "お問い合わせ",
          ContactUs: "お問い合わせ",
          Welcome: "Mirukuru オンラインストレージへようこそ！",
          PleaseStart:"[新規プロジェクト」をクリックし、プロジェクトを作成することから始めてください。",
          Moused:"GB を使用",
          Momax:"GB",
          NewProjectDescription:"新規プロジェクト作成するには、タイトルと簡単な説明を入力してください。",
          Title:"タイトル",
          Description:"説明",
          Cancel:"キャンセル",
          Create:"作成",
          Creating:"作成",
          ProjectEmpty:"このプロジェクトは空です。[アップロード] をクリックし、データをアップロードしてください。",
          UploadData:"アップロード",
          Progress:"進行状況",
          Edit:"編集",
          Delete:"削除",
          SelectALASFile:"LAS または LAZ ファイルをアップロードし、短い説明を書いて画像を添付してください。必要に応じて、このファイルに使う処理を選択してください。。",
          LASLAZFile:"LAS/LAZファイル（必須）",
          Image:"画像 (最大10MB)",
          Materials:"マテリアル",
          PhotosReconstruction:"写真",
          SelectPhotos:"ガウシアン・スプラッティング再構成に使用する写真セットを選択してください。生成されるモデルは、写真のEXIFに含まれるGPS情報でジオリファレンスされます。なお、屋内で撮影した写真や被写体に寄った写真は、モデルの正確な位置決めに不適切なGPS情報を含む場合があります。",
          PhotosSelectedCount:"選択中: {{count}} 枚",
          PhotosSelectedCount_other:"選択中: {{count}} 枚",
          dragndrop:"ドラッグ＆ドロップまたはクリックで選択",
          Upload:"アップロード",
          Uploading:"アップロード",
          ErrorUpload:"データのアップロード中にエラーが発生しました。もう一度お試しください。",
          ErrorType:"提供されたファイルはLASまたはLAZフォーマットではありません。LASまたはLAZファイルを選択してください。",
          ErrorSpace:"選択したファイルは、ストレージ容量を超えています。ストレージ容量増設をご希望の場合は、当社までご連絡ください。",
          ErrorMaxFileSpace:"選択したファイルが最大サイズを超えています。より小さいファイルを選択してください。",
          ErrorNoFile:"ファイルを1つ選択してください。",
          ErrorMultipleFiles:"OBJとそのマテリアルを含める場合を除き、アップロードできるファイルは1つだけです。",
          ErrorObjMultiple:"OBJファイルは1つだけ選択してください。",
          ErrorObjBundleTypes:"OBJの同梱ファイルは.mtl とテクスチャ（.jpg、.jpeg、.png）のみです。",
          ErrorNoFileOrPhotos:"点群ファイル、または写真を3枚以上選択してください。",
          ErrorMinimumPhotos:"写真は最低3枚選択してください。",
          UploadSuccess:"データは正常にアップロードされました！",
          EditProject:"プロジェクトの編集",
          PleaseModify:"プロジェクト名と概略を修正してください。",
          NewTitle:"新規タイトル",
          NewDescription:"新着情報",
          Save:"保存",
          Saving:"保存",
          Product:"製品",
          Products:"製品紹介",
          Download:"ダウンロード",
          Share:"共有",
          DeleteProject:"プロジェクトの削除",
          DeleteProjectDesc:"削除されたプロジェクトは、添付されたデータも含めて復元できません。ご注意ください。",
          Deleting:"削除",
          errorDeleteProject:"プロジェクトの削除中にエラーが発生しました。もう一度やり直してください。",
          successDeleteProject:"プロジェクトは削除されました",
          errorEditProject:"プロジェクトの編集中にエラーが発生しました。もう一度やり直してください。",
          successEditProject:"プロジェクトは編集されました！",
          errorCreateNewProject:"プロジェクト作成中にエラーが発生しました。タイトルと概略が正しく入力されているか確認してください。",
          successCreateNewProject:"新規プロジェクトの作成は成功しました！",
          Close:"閉じる",
          ShareFile:"共有ファイル",
          ShareProduct:"共有製品",
          ShareFileDesc:"24時間有効のファイルへのリンクが自動的にクリップボードにコピーされます。このリンクを共同作業者に自由にシェアしてください。このリンクがあれば、誰でもファイルをダウンロードすることができます。",
          CreateLink:"リンク作成",
          LinkSuccess:"リンクがクリップボードにコピーされました！",
          DeleteFile:"ファイルの削除",
          DeleteFileDesc:"削除されたファイルは復元できません。 関連製品も削除されます。ご注意ください。",
          successDeleteFile:"データは削除されました！",
          errorDeleteFile:"データ削除中にエラーが発生しました。",
          ErrorAlreadyExists:"このファイルはすでにアカウントにアップロードされています。",
          ForgotPassword:"パスワードの再設定・変更",
          ResetPassword:"パスワードをリセット",
          ResetPasswordDesc:"ここにメールアドレスを入力してください。メールアドレスがデータベースにあるアカウントに一致する場合、新しいパスワードを設定するための検証コードが送信されます。",
          Send:"コードを送信",
          SuccessResetPassword:"コードがお客様のメールアドレスに送信されました。",
          ErrorResetPassword:"入力されたメールアドレスは登録されているアカウントと一致しません。",
          NewPasswordDesc:"電子メールで受け取った認証コードと新しいパスワードをここに入力してください。",
          Code:"認証コード",
          SuccessNewPassword:"パスワードが変更されました！",
          ErrorNewPassword:"新しいパスワードの設定中にエラーが発生しました。認証コードを確認してください。",
          errorDownloadFile:"ファイルのダウンロード中にエラーが発生しました。もう一度お試しください。",
          Searchfile:"ファイル検索",
          Sortby:"並び替え",
          Date:"日付",
          Latest:"最新",
          Oldest:"最旧",
          Size:"サイズ",
          Biggest:"最大",
          Smallest:"最小",
          File:"ファイル",
          View:"表示",
          ErrorPotree:"レンダリング中にエラーが発生しました。もう一度お試しください。",
          ErrorPointCloudLoading:"データセットの変換中にエラーが発生しました。詳細については弊社チームまでお問い合わせください。",
          NewPassword:"パスワードを入力してください。",
          ReNewPassword:"パスワードをもう一度入力してください。",
          minLengthPW: "パスワードは8文字以上",
          specialCharPW: "パスワードには特殊文字が含まれている必要があります。",
          numberPW: "パスワードには数字が含まれている必要があります。",
          capitalPW: "パスワードには半角大文字が含まれている必要があります。",
          lowercasePW: "パスワードは半角小文字が含まれている必要があります。",
          matchPW: "パスワードの一致",
          TooManyAttempt:"試行回数の制限を超えました。時間をおいてからやり直してください。",
          CodeMismatchError:"提供されたコードが一致しません。認証コードをもう一度確認してください。",
          ViewerNotReady:"このファイルのビューアーは準備中です。数分後に再度お試しください。",
          UploadingContent:"コンテンツのアップロード",
          MaximumSize:"最大サイズ",
          GettingViewerReady:"ビューアーは準備中",
          AboutButton:"お知らせ",
          About:"Mirukuruオンラインストレージについて",
          AboutInfo:"Mirukuruオンラインストレージは、3D点群をオンラインで保存し、可視化するために設計された強力なソフトウェアツールです。点群データをインタラクティブに検索し、簡単に分析することができます。",
          SoftwareStructure:"ソフトウェアの構造",
          SoftwareStructureInfo:"このソフトウェアは、Amazon Web Servicesを通じて3D点群データを安全に保管し、オープンソースの点群レンダリングフレームワークであるPotreeを使用して高品質でインタラクティブなビジュアライゼーションを実現する、堅牢でスケーラブルなアーキテクチャで構築されています。",
          Potree:"Potree",
          PotreeInfo:"MirukuruオンラインストレージはPotreeとPotree Converterを使用し、ウェブブラウザで大規模な点群をレンダリングしています。Potreeとそのコンバーターは、そのパフォーマンスと様々なLiDARデータフォーマットとの互換性で有名です。PotreeとPotree Converterはどちらも ",
          Contact:"問合せ先",
          ContactInfo:"サポート、お問い合わせ、ご意見はこちら ",
          ThankYou:"Mirukuruオンラインストレージをご利用いただきありがとうございます！",
          TeamSign:"Mirukuru チーム",
          Demo:"このアカウントはデモンストレーションのみを目的としています。",
          UserEmpty:"このユーザーはまだデータをアップロードしていません。",
          ErrorFileNoSpace:"ファイル名にスペース（' '）を含めてはいけません。ファイル名を変更して再試行してください。",
          NoProductAdmin:"このファイルにはまだ製品は添付されていません。",
          UploadProduct:"製品を追加",
          AddNewProductAdmin:"新製品を追加",
          ErrorConverterHead:"このファイルではビューアは使用できません。",
          ErrorConverter1:"これは以下の2つの理由で発生しました：",
          ErrorConverter2:"いくつかの点は、LASヘッダーで定義されたバウンディング・ボックスから外れます。",
          ErrorConverter3:"Global Encoding（GE）フラグが WKT に設定されていません。これは Point Data Record Format 6 - 10 の要件です。",
          ErrorConverter4:"例えば、-repair_bb引数付きのlasinfoを使用してバウンディングボックスを修復するか、グローバルエンコーディング（GE）フラグがWKTに設定されていることを確認してから、ファイルを再度アップロードしてください。",
          ErrorConverter5:"それでも問題が解決しない場合は、弊社までご連絡ください。",
          SuccessEditUser:"ユーザーが正常に編集されました。",
          ErrorEditUser:"ユーザー編集中にエラーが発生しました。",
          AccountActivity:"アカウントの履歴",
          Storage:"ストレージ ",
          UserCreated:"ユーザー作成日 ",
          Total:"合計 ",
          UserSettings1:"ユーザー設定",
          UserSettings2:"ストレージ容量",
          UserSettings3:"このユーザーがアップロードしたファイルを格納するディレクトリの最大サイズ。",
          UserSettings4:"月間最大アップロード数",
          UserSettings5:"ログイン中に、このユーザーが当月にアップロードしたファイル数をチェックします。この数が以下の制限値以上である場合、ユーザーは新しいファイルをアップロードするために、次の月の初めまで待つ必要があります。",
          UserDeletionTitle:"ユーザー削除",
          UserDeletionDescription:"このボタンをクリックすると、ユーザーとそのデータがデータベースから完全に削除されます。一度削除したデータを復元する方法はありません。",
          DeleteUser:"削除",
          ConfirmUserDeletionTitle:"削除の確認",
          ConfirmUserDeletionDescription:"本当に続行しますか？",
          AdminPanel:"管理パネル",
          StorageStatistics:"ストレージ統計",
          Empty:"空",
          HasBeenAddedToTheFile:" が追加された。ファイル: ",
          CreatedOn:"作成日 ",
          UpdatedOn:"最終更新日 ",
          EditData:"データ編集",
          PleaseModifyData:"新しい概略または画像を提供してください。",
          SuccessEditFile:"ファイルが変更されました。",
          ErrorEditFile:"ファイル変更中にエラーが発生しました。",
          UploadQueue:"アップロードキュー",
          UploadCompleted:"アップロード完了",
          UploadFailed:"アップロード失敗",
          NewUser:"新規ユーザーの作成",
          NewUserDescription:"新規ユーザー作成に必要な項目を入力してください。",
          Name:"氏名",
          Company:"会社",
          errorCreateNewUser:"ユーザー作成中にエラーが発生しました。",
          successCreateNewUser:"ユーザー作成に成功しました。",
          successSendInvitationEmail:"招待メールを送信しました。",
          ErrorDeleteUser:"ユーザー削除中にエラーが発生しました。",
          SuccessDeleteUser:"ユーザーを削除しました。",
          errorSendInvitationEmail:"招待メールの送信に失敗しました。",
          warningNameNewUser:"新しいユーザーの名前を入力してください。",
          warningCompanyNewUser:"新規ユーザーの会社名をご記入ください。",
          warningEmailNewUser:"新規ユーザーの有効なメールアドレスを入力してください。",
          warningPasswordNewUser:"新規ユーザーの有効なパスワードを入力してください。",
          warningSelectOneService:"新規ユーザーには、少なくとも1つのサービスを選択してください。",
          FilterUsers:"フィルタリング・ユーザー",
          LastLogin:"最終ログイン日 ",
          MaxUploadReached:"今月のアップロードは上限に達しました。ファイルをアップロードする必要がある場合は、お問い合わせください。",
          NumberFile:"アップロードされたファイル数",
          NumberGo:"アップロードされた GB 量",
          MonthlyUsage:"月間利用枠",
          TotalStorage:"総ストレージ容量",
          FileNotReadyForDeletion:"このファイルは現在処理中です。しばらくしてからもう一度お試しください。",
          ProcessingOptions:"処理要求",
          Requests:"要求",
          Options:"オプション",
          "forest-report":"森林レポート",
          "forest-report-diameter":"直径",
          "forest-report-position":"位置",
          "forest-report-height":"高さ",
          "noise-filtering":"ノイズ・フィルタリング",
          "ground-extraction":"地盤抽出",
          "buildings-segmentation":"建物セグメント",
          "trees-segmentation":"樹木のセグメンテーション",
          "crowns-analysis":"樹冠分析",
          "Project":"プロジェクト",
          "Projects":"プロジェクト",
          Settings:"ユーザーのストレージ容量と月間費用の設定。",
          HistoryRequests:"このユーザーに対して実行された処理要求の履歴。",
          BuildingSegmentation:"都市の点群から建物の構造を自動的に分離して抽出します。高度なクラスタリングと平面フィッティングを使用して、密集した都市スキャンでも屋根、ファサード、エッジを明確にします。都市計画やビジュアライゼーションに使用できるクリーンな 3D 建物フットプリントとメッシュを出力します。",
          "buildings-segmentation-output":".OBJ形式で出力した、検出された各ビルのメッシュモデル",
          CrownsAnalysis:"航空LiDAR計測に合わせて開発されたこのツールは、大規模な森林キャノピーの個々の樹冠を検出します。樹冠の主要な指標である高さと投影面積を計算し、林冠の健全性と構造を評価します。結果には、森林生態学者や造林計画用のシェープファイル形式の樹冠マップが含まれます。",
          "crowns-analysis-output":"個々の樹冠ポリゴンを含むESRI Shapefileバンドル（.shp/.shx/.dbf/.prj）。",
          ForestReport:"地盤を基準とした点群からスタンドレベルの包括的なレポートを生成します。樹木の指標（胸高直径（DBH）、高さ分布、樹木の位置）をすぐに共有できるCSVに集約します。",
          "forest-report-output":"点群から得られた樹木ごとの統計情報とスタンドレベルの統計情報の両方をリスト化したCSVファイル。",
          GroundExtraction:"高精度なデジタル地形モデル（DTM）を構築する汎用の地表面抽出ツール。漸進的なモルフォロジカルフィルタと補間フィルタを用いて、植生や複雑な都市部でも地表点のみを分類・保持し、それらの地表点を連続曲面で近似します。",
          "ground-extraction-output":"ジオリファレンス付きGeoTIFF（.tif）デジタル地形モデル（DTM）。",
          NoiseFiltering:"ユニバーサルなノイズ除去機能により、処理前に点群データをクリーンアップ。統計的な異常値除去と半径ベースのフィルタを適用し、微細なディテールを保持しながら、センサーノイズやスプリアスポイントを除去します。その結果、高品質ですぐに使用できる点群が得られ、後続のタスクの精度が向上します。",
          "noise-filtering-output":"センサーノイズと外れ値を除去したLAZ圧縮点群（.laz）。",
          TreeSegmentation:"地上または低高度のスキャン用に設計されたこのモジュールは、各樹木を独自の点群に分割します。バイオマス推定、樹木ごとのモニタリング、または詳細なモデリングのための樹木ごとのデータセットが得られます。",
          "trees-segmentation-output":"LAZ圧縮された点群ファイル(.laz)にTreeIDフィールドを追加。",
          ChooseYourPanel:"パネルの選択",
          ChooseYourPanelDescription:"管理者として、入力するダッシュボードを選択できます。",
          Administrator:"管理者",
          User:"ユーザー",
          Service:"奉仕",
          ServiceClassic:"クラシック",
          ServiceMapping:"マッピング",
          ChooseYourService:"サービスの選択",
          ChooseYourServiceDescription:"両方のサービスにご加入の方は、ログインしたい方を選択してください。",
          ProcessingOptionsSubtitle:"アップロード後に実行する分析を選択してください。複数のオプションを組み合わせることが可能です。結果はデータセットのサブメニューからアクセスできます。",
          "crowns-analysis-subtitle": "1本ずつの樹冠（じゅかん）を見つけて、樹冠の高さと表面積を計測します。樹冠ポリゴンと木ごとの数値テーブルを出力します。",
          "forest-report-subtitle": "林分（スタンド）全体の統計をまとめます。木の本数・位置・高さ・直径を集計し、主な指標をCSVで出力します。",
          "ground-extraction-subtitle": "地面ポイントと地面でないポイントを分け、きれいなDTM（地形モデル）を作ります。ラスタDEMも出力します。",
          "noise-filtering-subtitle": "外れ値やとびちり点を除去して、エッジ（境目）を保ちます。",
          "trees-segmentation-subtitle": "点群から木を1本ずつ分けます（ジオメトリ情報を使用）。木ごとのポイントIDを作成し、次の分析に使えます.",
          DownloadUserManual:"ユーザーマニュアル",
          FetchingData:"データ取得中",
          Archive:"アーカイブ",
          SelectArchive:"ZIPアーカイブを選択し、簡単な説明を追加してください",
          ErrorNoArchive:"アーカイブファイルを選択してください",
          // EPSG Selection Dialog
          SelectCoordinateSystem:"座標系を選択",
          DetectedEPSG:"検出されたEPSG",
          NotDetected:"検出されませんでした",
          FileCenter:"ファイル中心",
          CoordinateSystem:"座標系",
          Zone:"系",
          EstimatedZTranslation:"推定Z補正値（ジオイド高）",
          CalculatingZTranslation:"Z補正値を計算中...",
          ConvertedCenter:"変換後の中心",
          Confirm:"確認",
          ErrorMissingHeader:"ファイルヘッダー情報がありません",
          ErrorReadingHeader:"ファイルヘッダーの読み取りエラー",
          ErrorNoGeoReference:"ご注意ください。アップロードされたファイルには地理参照情報が含まれていません。ビューアで正しく表示することができません。別のファイルを選択してください。",
          EpsgDialogExplanation:"3DビューアはWGS84楕円体に基づく楕円体高を使用します。点群データが標高（ジオイドモデルに基づく）を使用している場合、背景地図と正しく重ねるためにZ方向のオフセットが必要です。座標系を確認し、以下のZ補正値をご確認ください。",
          ZTranslationExplanation:"この値（ジオイド高N）がZ座標に加算され、標高から楕円体高に変換されます。",
          // Height Type Selection
          HeightType:"高さの種類",
          EllipsoidHeight:"楕円体高",
          OrthometricHeight:"標高（ジオイド高）",
          EllipsoidHeightDescription:"データはすでに楕円体高（GPS/GNSS標高など）を使用しています。垂直補正は不要です。",
          OrthometricHeightDescription:"データは標高（海抜/ジオイド基準）を使用しています。垂直オフセットが適用されます。",
          EllipsoidNoTranslation:"垂直補正不要 - データはすでに楕円体高を使用しています。",
          ZTranslation:"Z補正値",
          DatasetLocation:"データセットの位置",
          GeoidSourceJapan:"ソース: GSIジオイド2011（日本）",
          GeoidSourceWorld:"ソース: EGM2008（世界）",
          FetchingGeoidJapan:"GSIジオイド2011（日本）から取得中...",
          FetchingGeoidWorld:"EGM2008（世界）から取得中...",
          // JGD2011 Zone Regions
          JGD2011_Zone1:"長崎県・鹿児島県の一部（離島）",
          JGD2011_Zone2:"福岡県・佐賀県・長崎県・熊本県",
          JGD2011_Zone3:"山口県・島根県・広島県",
          JGD2011_Zone4:"鳥取県・岡山県・兵庫県の一部",
          JGD2011_Zone5:"徳島県・香川県・愛媛県・高知県",
          JGD2011_Zone6:"京都府・大阪府・奈良県・和歌山県・兵庫県の一部",
          JGD2011_Zone7:"石川県・富山県・岐阜県・愛知県",
          JGD2011_Zone8:"新潟県・長野県・山梨県・静岡県",
          JGD2011_Zone9:"東京都・福島県・栃木県・茨城県・埼玉県・千葉県・群馬県・神奈川県",
          JGD2011_Zone10:"青森県・秋田県・山形県・岩手県・宮城県",
          JGD2011_Zone11:"北海道（西部）",
          JGD2011_Zone12:"北海道（中央部）",
          JGD2011_Zone13:"北海道（東部）",
          JGD2011_Zone14:"東京都の一部（小笠原諸島）",
          JGD2011_Zone15:"沖縄県（本島）",
          JGD2011_Zone16:"沖縄県（先島諸島）",
          JGD2011_Zone17:"沖縄県（尖閣諸島）",
          JGD2011_Zone18:"東京都の一部（南鳥島）",
          JGD2011_Zone19:"東京都の一部（硫黄島）",
          Files: "ファイル",
          NoSearchResults: "検索に一致するファイルはありません。",
          ClearFilter: "クリア",
          // Time-limited platform access
          AccessEndedTitle: "ご利用期間が終了しました",
          AccessEndedMessage: "Mirukuru オンラインストレージのご利用期間が終了しました。契約の更新およびアクセスの再開をご希望の場合は、Mirukuru 営業担当までお問い合わせください。",
          AccessEndedMessageTrial: "Mirukuru オンラインストレージの体験期間が終了しました。引き続きご利用いただくには、Mirukuru 営業担当までお問い合わせください。",
          ContactSales: "営業に問い合わせる",
          BackToLogin: "ログインに戻る",
          TrialPeriodWeeks: "体験期間（週）",
          TrialPeriodHelp: "新規ユーザーはこの週数の間プラットフォームをご利用いただけます。期間終了後は営業へのお問い合わせをご案内します。",
          warningTrialWeeks: "体験期間は1週間以上に設定してください。",
          AccessManagementTitle: "アクセス・契約",
          AccessStatus: "アクセス状況",
          Plan: "プラン",
          PlanUnlimited: "無期限",
          PlanTrial: "体験",
          PlanPaid: "有料",
          AccessActive: "有効",
          AccessExpiredLabel: "期限切れ",
          AccessExpiresOn: "アクセス期限",
          AccessValidUntil: "ご利用期限",
          AccessStartedOn: "現在の期間の開始日",
          NeverExpires: "無期限（期限なし）",
          DaysRemainingValue: "残り {{count}} 日",
          ActivatePaidAccess: "有料アクセスを有効化",
          Duration: "期間",
          DurationMonths: "{{count}} か月",
          ExtendTrial: "体験期間を延長",
          RevokeAccess: "アクセスを取り消す",
          ConfirmRevokeTitle: "アクセスを取り消しますか？",
          ConfirmRevokeMessage: "このユーザーは直ちにプラットフォームへのアクセスを失い、次回ログイン時に営業へのお問い合わせをご案内します。続行しますか？",
          AccessUpdatedSuccess: "アクセスを更新しました。",
          AccessUpdatedError: "アクセスの更新中にエラーが発生しました。",
          // Viewer translations merged from src/viewer/locale/i18n.js
          ...viewerTranslations.jp,
        },
      },
    },
  });

export default i18n;
